import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { MaskReveal, Reveal } from "./Reveal";
import { SERVICES } from "./data";

export const Services = () => {
  const [active, setActive] = useState(SERVICES[0].id);
  const activeService = SERVICES.find((s) => s.id === active);

  return (
    <section id="services" className="relative bg-ink-950 py-28 md:py-44">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <div className="mb-16 flex flex-col justify-between gap-6 md:mb-24 md:flex-row md:items-end">
          <div>
            <Reveal>
              <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-gold">/ What I Do</span>
            </Reveal>
            <h2 className="mt-5 font-oswald text-6xl font-700 uppercase leading-[0.85] tracking-tighter text-white md:text-8xl">
              <MaskReveal lines={["The", "Repertoire"]} />
            </h2>
          </div>
          <Reveal delay={0.2}>
            <p className="max-w-xs text-sm leading-relaxed text-zinc-400">
              One DJ, every kind of night. Hover a discipline to preview the energy.
            </p>
          </Reveal>
        </div>

        <div className="grid gap-12 lg:grid-cols-[1.1fr_0.9fr]">
          {/* Interactive list */}
          <div className="flex flex-col">
            {SERVICES.map((s) => (
              <div
                key={s.id}
                data-testid={`service-item-${s.id}`}
                onMouseEnter={() => setActive(s.id)}
                onClick={() => setActive(s.id)}
                className={`group relative cursor-pointer border-b border-white/10 py-8 transition-colors duration-500 ${
                  active === s.id ? "" : "opacity-50 hover:opacity-90"
                }`}
              >
                <div className="flex items-baseline justify-between gap-4">
                  <div className="flex items-baseline gap-5 md:gap-8">
                    <span className="font-mono text-xs text-gold">{s.index}</span>
                    <h3 className="font-oswald text-4xl font-600 uppercase tracking-tight text-white md:text-6xl">
                      {s.title}
                    </h3>
                  </div>
                  <ArrowUpRight
                    className={`shrink-0 text-gold transition-all duration-500 ${
                      active === s.id ? "translate-x-0 translate-y-0 opacity-100" : "-translate-x-2 translate-y-2 opacity-0"
                    }`}
                    size={28}
                  />
                </div>
                <AnimatePresence>
                  {active === s.id && (
                    <motion.p
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.4 }}
                      className="overflow-hidden pl-9 pt-4 text-sm leading-relaxed text-zinc-400 md:max-w-md md:pl-16"
                    >
                      {s.copy}
                    </motion.p>
                  )}
                </AnimatePresence>
              </div>
            ))}
          </div>

          {/* Preview image */}
          <div className="relative hidden aspect-[4/5] overflow-hidden lg:block">
            <AnimatePresence mode="wait">
              <motion.div
                key={activeService.id}
                initial={{ opacity: 0, scale: 1.08 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
                className="absolute inset-0"
              >
                <img src={activeService.img} alt={activeService.title} className="h-full w-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-ink-950 via-ink-950/20 to-transparent" />
                <div className="absolute bottom-0 left-0 p-8">
                  <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-gold">{activeService.tag}</span>
                  <p className="mt-2 font-oswald text-3xl font-600 uppercase tracking-tight text-white">
                    {activeService.title}
                  </p>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>
        </div>
      </div>
    </section>
  );
};
